
import Vue from 'vue'
import {Component, Prop, Watch} from "vue-property-decorator";
import buyAddressApi from "@/common/api/business";
import {Util} from "@/common/util";
import billPrint from "@/components/print.vue";
import moment from "moment/moment";

@Component({
  components: {billPrint}
})
export default class GoodSale extends Vue {
  @Prop({ type: Boolean, default: true }) showReceiptPrint: boolean; // 修正 prop 定义
  @Prop({ type: String, default: 'print' }) printDom: string; // 修正 prop 定义
  private keydownHandler: ((e: KeyboardEvent) => void) | null = null;
  private buyAddressApi: any = new buyAddressApi();
  private visible:boolean = false
  private printDialog: boolean = false;
  private remarkVisible:boolean = false
  private printRemark:string = ''
  private isLoading:boolean = false
  private ischeck_goods: number = 1;
  private category: any = [];
  private goodsList: any = [];
  private selectgoodsList: any = [];
  private goodsprice: number = 0;
  private forms: any = {
    category_id: 0,
  };
  private selectgoods: any = new Set();
  private order_id:string = ''
  private tableinfo:any = {}
  private shopInfo ={}
  private show(order_id:string,tableinfo:any):void{
    this.order_id = order_id
    this.tableinfo = tableinfo
    this.goodsell();
    let shopInfo  = localStorage.getItem('shopInfo')
    if(shopInfo){
      this.shopInfo = JSON.parse(shopInfo)
    }
  }

  private close():void{
    this.visible = false
  }

  private goodsell(): void {
    // this.getscanCode(1);
    this.goodsprice = 0;
    this.restForms();
    this.ischeck_goods = 1;
    this.goodscategory();
    this.goodslists();
    this.selectgoodsList = [];
    this.selectgoods = new Set();
    this.visible = true
    this.focusInput()
  }
  private restForms(): void {
    this.forms = new Util().clearObject(this.forms);
    this.forms.category_id = 0;
  }
  private goodscategory(): void {
    this.buyAddressApi.goodscategory({}, (res: any) => {
      this.category = res.data.list;
    });
  }
  private currentTime:string = ''
  private showPrintInfo():void{
    this.remarkVisible = false
    this.printDialog = true
    this.currentTime = moment().format('YYYY-MM-DD HH:mm:ss')
  }

  private goodcode: string = "";
  private scanCodeadd(goodcode:string|number): void {
    this.buyAddressApi.goodscan(
        {
          bar_code: goodcode,
        },
        (res: any) => {
          this.selectgood(res.data.item);
        }
    );
  }


  private removegood(row: any): void {
    this.selectgoods.delete(row);
    this.selectgoodsList = [...this.selectgoods];
    this.getgoodsprice();
  }

  private deleteGood(row:any): void {
    const arr= this.selectgoodsList.filter((item:any)=>item.id!==row.id)
    this.selectgoodsList = [...arr]

    this.goodsList.forEach((item:any)=>{
      if(item.id === row.id){

        item.is_select = 0
      }
    })
    this.goodsList =[...this.goodsList]
    this.getgoodsprice();
  }

  private selectgood(row: any): void {
    row.num = 1;
    if (this.selectgoods.size > 0) {
      this.selectgoods.forEach((item: any) => {
        console.log(item);
        if (item.id != row.id) {
          this.selectgoods.add(row);
        }
      });
    } else {
      this.selectgoods.add(row);
    }
    this.selectgoodsList = [...this.selectgoods];
    this.getgoodsprice();
  }
  private getgoodsprice(): void {
    this.goodsprice = 0;
    for (let i of this.selectgoodsList) {
      this.goodsprice += i.num * i.price;
    }
  }

  private printReceipt():void{
    if(!this.selectgoodsList.length){
      this.$message.warning('请添加商品')
      return
    }
    this.printRemark = ''
    this.remarkVisible = true;
  }

  private async buygoods() {
    if(this.isLoading){
      return;
    }
    this.isLoading = true
    let goods = this.selectgoodsList.map((item:any)=>{
      return `${item.id}=${item.num}`
    }).toString()
    if (this.order_id) {
      this.buyAddressApi.goodsSalecart(
          {
            order_id: this.order_id,
            cart_goods: goods,
            desk_id:this.tableinfo.id,
          },
          () => {
            Util.showToast("添加成功");
            this.$emit('success')
            this.visible = false;
            setTimeout(()=>{
              this.isLoading = false
            },300)
          },()=>{
            setTimeout(()=>{
              this.isLoading = false
            },300)
          }
      );
    } else {
      console.log('2222222222222')
      let goods = "";
      for (let i of this.selectgoodsList) {
        goods += i.id + "=" + i.num + ",";
      }
      this.buyAddressApi.goodsSale({ goods: goods }, (res: any) => {
        this.$emit('success',{orderinfo:res.data,selectgoodsList:this.selectgoodsList})
        this.visible = false;
        setTimeout(()=>{
          this.isLoading = false
        },300)
      },()=>{
        setTimeout(()=>{
          this.isLoading = false
        },300)
      });
    }
  }
  private goodslists(): void {
    this.buyAddressApi.goodsquery(
        {
          ...this.forms,
          page: 1,
          limit: 200,
        },
        (res: any) => {
          res.data.list.forEach((item:any)=>item.is_select=0)
          this.goodsList = res.data.list;
        }
    );
  }

  private setnum(type: number, row: any): void {
    if (type == 0) {
      if (row.num > 1) {
        row.num--;
      }
    } else {
      row.num++;
    }
    this.selectgoodsList = [...this.selectgoodsList];
    this.getgoodsprice();
  }

  private selectGoods(index:number,item:any):void{
    this.goodsList[index].is_select = 1
    this.addSelectList(this.goodsList[index])
  }

  private changeCheckBox(index:number,item:any):void{
    // this.goodsList[index].is_select = item.is_select===1?0:1
    this.goodsList[index].is_select = 1
    this.addSelectList(this.goodsList[index])
  }
  private addSelectList(good:any):void{
    let flag = this.selectgoodsList.some((item:any)=>item.id===good.id)
    if(!flag){
      good.num = 1
      this.selectgoodsList.unshift(good)
      this.getgoodsprice()
    }
    // const arr= this.selectgoodsList.filter((item:any)=>item.id!==good.id)
    // this.selectgoodsList = [...arr]
  }
  private scanTimer: number | null = null;
  private isScanCodePrint:boolean = false
  private scanCodeInputValue:string = ''
  private focusInput():void {
    this.$nextTick(() => {
      // 确保 DOM 更新完成后再聚焦
      if (this.$refs.scanCodeInputRef) {
        console.log('获取焦点')
        this.$refs.scanCodeInputRef.focus()
        this.scanCodeInputValue = ''; // 清空输入框
      }
    });
  }
  private handleScanCodeInputBlur():void{
    console.log('失去焦点')
    setTimeout(() => {
      this.focusInput();
    }, 10);
  }
  // 监听输入值变化（备选方案）
  @Watch('scanCodeInputValue')
  onScanCodeValueChange(newVal: string) {
    // 清除已有定时器
    if (this.scanTimer) {
      clearTimeout(this.scanTimer);
    }

    // 设置新定时器：100ms内无新输入视为扫码完成
    this.scanTimer = window.setTimeout(() => {
      if (newVal&&newVal.length>=8) {
        this.processScanCode(newVal);
      }
    }, 100);
  }


  // 处理扫码结果
  private processScanCode(code: string) {
    // 清除定时器
    if (this.scanTimer) {
      clearTimeout(this.scanTimer);
      this.scanTimer = null;
    }

    // 执行操作
    // this.payrequest(code);
    this.scanCodeadd(code);
    // 清空输入框并保持聚焦
    this.scanCodeInputValue = '';
    this.$refs.scanCodeInputRef.focus();
  }
  private removeKeydownListener() {
    if (this.keydownHandler) {
      document.removeEventListener('keydown', this.keydownHandler);
      this.keydownHandler = null;
    }
  }
  private getscanCode(type: number): void {
    console.log('监听扫码枪扫码')
    let that = this;
    let str = "";
    this.keydownHandler = async function (e: any) {
      if (e.target.tagName !== "BODY") {
        console.log('0000000000000',str);
        str = "";
      } else {
        if (e.keyCode !== 13) {
          if (e.keyCode >= 32 && e.keyCode <= 126) {
            let k = e.key;
            str += k;
          }
          console.log('111')
        } else {
          console.log('222')
          if (str) {
            console.log(str);
            that.goodcode = str;
            str = "";
            that.scanCodeadd();
          }
        }
      }
    };
    document.addEventListener('keydown', this.keydownHandler);
  }

  @Watch("visible")
  private changescanCode(): void {
    if (!this.visible) {
      console.log('关闭微信扫码提示弹窗goodSaleDioalog')
      // this.removeKeydownListener()
    }
  }
}
